<template>
    <div>
        <div class="Main" style="padding-bottom:0;">
            <div class="topMain">
                <div slot="header" class="clearfix">
                    <span>场景联动控制日志</span>
                </div>
            </div>
            <div style="margin-top: 15px;">
                <!-- <el-card class="box-card"> -->
                    <el-form :model="queryParams" ref="queryParams" :inline="true" class="demo-form-inline">
                        <el-form-item label="规则名称" prop="ruleName">
                            <el-input placeholder="请输入" v-model="queryParams.ruleName"></el-input>
                        </el-form-item>
                        <el-form-item label="策略名称" prop="strategyName">
                            <el-input placeholder="请输入" v-model="queryParams.strategyName"></el-input>
                        </el-form-item>
                        <el-form-item label="状态" prop="logStatus">
                            <el-select placeholder="请选择" v-model="queryParams.logStatus">
                                <el-option label="异常" value="0"></el-option>
                                <el-option label="成功" value="1"></el-option>
                                <el-option label="失败" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建时间" prop="createTime">
                            <el-date-picker v-model="createTime" type="datetimerange" range-separator="至"
                                start-placeholder="开始日期" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd  HH:mm"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item class=" checkPlandiv_but">
                            <el-button type="primary" @click="getList()">搜索</el-button>
                            <el-button @click="resetQuery"><i class="el-icon-refresh"></i>重置</el-button>
                        </el-form-item>
                    </el-form>
                <!-- </el-card> -->
            </div>
            <div>
                <el-card class="box-card" style="margin-top: 30px;">
                    <el-table :data="resultPage" style="width: 100%">
                        <el-table-column label="序号" type="index" width="50">
                        </el-table-column>
                        <el-table-column prop="ruleName" label="规则名称" width="" />
                        <el-table-column prop="strategyName" label="策略名称" width="" />
                        <el-table-column prop="totalNum" label="执行设备数" width="" />
                        <el-table-column prop="progressNum" label="进行中设备数" width="" />
                        <el-table-column prop="successNum" label="下发成功设备数" width="" />
                        <el-table-column prop="failNum" label="下发失败设备数" width="" />
                        <el-table-column prop="logStatus" label="状态" width="">
                            <template slot-scope="scope">
                                {{ scope.row.logStatus == 0 ? '异常' : scope.row.logStatus == 1 ? '成功' : '失败' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="createDate" label="创建时间" width="" />
                        <el-table-column label="操作" width="">
                            <template slot-scope="scope">
                                <el-button class="el-icon-s-order" type="text"
                                    @click="handleDetails(scope.row)">详情</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                  
                </el-card>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="queryParams.currentPage" :page-sizes="[10, 20, 50, 100]"
                        :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
            </div>
        </div>
        <SceneLinkageLogDetail ref="SceneLinkageLogDetail"></SceneLinkageLogDetail>
    </div>
</template>

<script>
import API from "../../api/api";
import SceneLinkageLogDetail from "./SceneLinkageLogDetail.vue"
export default {
    components: {
        SceneLinkageLogDetail
    },
    data() {
        return {
            queryParams: {
                ruleName:'',
                strategyName:'',
                createTime:[],
                logStatus:null,
                currentPage: 1,
                pageSize: 10,
            },
            createTime: null,
            resultPage: [],
            total: 0
        }
    },
    created() {
        this.getList()
    },
    methods: {
        getList() {
            if (this.createTime) {
                this.queryParams.createTimeBegin = this.createTime[0]
                this.queryParams.createTimeEnd = this.createTime[1]
            }else{
                this.queryParams.createTimeBegin=null
                this.queryParams.createTimeEnd =null
            }
            API.platformRuleLogList(this.queryParams).then(res => {
                this.resultPage = res.data.resultPage
                this.total = res.data.total
            })
        },
        // 详情
        handleDetails(row) {
            this.$refs.SceneLinkageLogDetail.show(row)
        },
        //分页
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.queryParams.currentPage = 1;
            this.getList()
        },
        handleCurrentChange(val) {
            this.queryParams.currentPage = val;
            this.getList()
        },
        // 重置resetQuery
        resetQuery() {
            this.$nextTick(() => {
                this.$refs["queryParams"].resetFields();
                this.createTime = null
                this.queryParams.currentPage = 1
                this.getList();
            })
        }
    },
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/views/platform/SceneLinkageLog.vue